<template>
  <div
    class="dashed-border-wrapper"
    :style="{ borderRadius: radius + 'px' }"
    v-bind="$attrs"
  >
    <svg
      class="border-svg"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      preserveAspectRatio="none"
    >
      <rect
        x="0"
        y="0"
        width="100%"
        height="100%"
        :rx="radius"
        :ry="radius"
        fill="none"
        :stroke="color"
        :stroke-width="strokeWidth"
        :stroke-dasharray="dashArray"
        :stroke-linecap="linecap"
      />
    </svg>
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  color?: string;
  radius?: number;
  linecap?: 'butt' | 'round' | 'square';
  dashArray?: string;
  strokeWidth?: number;
}

const props = withDefaults(defineProps<Props>(), {
  color: 'var(--border, #ccc)',
  radius: 8,
  linecap: 'round',
  dashArray: '6 8',
  strokeWidth: 3,
});
</script>

<style scoped>
.dashed-border-wrapper {
  @apply relative isolate;
}

.border-svg {
  @apply pointer-events-none absolute inset-0 z-0 h-full w-full;
}
</style>
